export const COLUMN_IDS = {
  SENTIMENT: 'SENTIMENT',
  HEADLINE: 'title',
  EVENT: 'newsCategoryName',
  PUBLICATION_DATE: 'publicDate',
}
